import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ParametrosService } from "src/app/services/parametros.service";
import { MicroempresarioService } from "../services/microempresario.service";
import { UserService } from "../../services/user.service";
import { BancoldexService } from "src/app/comun/services/bancoldex.service";
import { SweetAlertService } from "../../services/sweet-alert.service";
import { ModalService } from "src/app/shared/service/modal.service";
declare var $: any;
//Constantes
const mensajeElegirPropuesta = 'PAR-079';
const mensajeSeleccionarPropuesta = 'PAR-078';
@Component({
    selector: 'microempresario-propuestas',
    templateUrl: './propuestas.component.html',
    styleUrls: ['./propuestas.component.scss'],
    standalone: false
})
export class PropuestasComponent implements OnInit {
  idSolicitud: string = "";
  idPropuesta: string = null;
  idPropuestaSelect: string = null;
  idNegacion: number = 0;
  detalle: string = "";
  propuestas: any[] = [];
  negaciones: any[] = [];
  mensajeElegir: string;
  mensajeSeleccion: string;
  configuracionCondicionesFinancieras: any[] = [];
  listCondiciones: any[];
  idSegmento: any;
  //Archivos segmentos
  tiposDocumentos: any[] = [];
  documentos: any[] = [];
  constructor(private route: ActivatedRoute,
    private router: Router,
    private _user: UserService,
    private _microempresario: MicroempresarioService,
    private _parametro: ParametrosService,
    private _bancoldexService: BancoldexService,
    private _sweetAlert: SweetAlertService,
    public _modal: ModalService
  ) {
    this.idSolicitud = this.route.snapshot.params.id;
    this.getMensajePropuesta();
  }

  ngOnInit() {
    this.getPropuestas();
    this.getTipoNegacion();
  }

  getPropuestas() {
    this._microempresario.getPropuestas(this.idSolicitud)
      .subscribe((data: any) => {
        this.propuestas = data.propuestas;
      })
  }

  seleccionarPropuesta(idPropuesta: string) {
    this.idPropuestaSelect = idPropuesta;
    $('#seleccionarPropuesta').modal('show');
  }

  getTipoNegacion() {
    this._parametro.getTipoNegacionOfertas()
      .subscribe((response: any) => this.negaciones = response);
  }

  selectPropuesta(idPropuesta: string) {
    if (idPropuesta == null) {
      $('.propuestaRadio').prop('checked', false);
      this.idNegacion = 0;
    } else if (idPropuesta !== '0') {
      this.idNegacion = 0;
    }
    this.idPropuesta = idPropuesta;
    if (this.idPropuesta) {
      this.idSegmento = this.propuestas.find((dato) => dato.idPropuesta === idPropuesta)?.idSegmento;
      if (this.idSegmento) {
        this.getTiposDocumentoSegmento(this.idSegmento);
      }
    }
  }

  elegirOferta() {
    if (this.idSegmento != null) {
      if (this.verificarDocumentosObligatorios() && this.idPropuesta != '0') {
        $('#elegirOferta').modal('show');
      } else {
        this._sweetAlert.errorModal("Error!", true,
          'Documentos obligatorios (*) incompletos, no se puede enviar solicitud hasta terminar el proceso.');
      }
    } else if (this.idPropuesta != '0') {
      $('#elegirOferta').modal('show');
    } else {
      this.savePropuesta();
    }
  }

  savePropuesta() {
    if (this.idNegacion != 0) {
      let body = {
        idSolicitud: this.idSolicitud,
        idTipoNegacionPropuestas: this.idNegacion,
        idUsuario: +this._user.getUser().idUsuario,
        configuracionCondicionesFinancieras: this.configuracionCondicionesFinancieras,
        otro: this.detalle
      };
      this._microempresario.negarPropuesta(body)
        .subscribe((response: any) => {
          if (response.exitoso) {
            this._sweetAlert.successModal(response.mensaje);
            this.router.navigateByUrl('/microempresario/home');
          } else {
            this._sweetAlert.errorModal("Error!", true, 'Se ha presentado un error');
          }
        })
    } else {
      let json = {
        idSolicitud: this.idSolicitud,
        idPropuesta: this.idPropuesta === '0' ? null : this.idPropuesta,
        idUsuario: +this._user.getUser().idUsuario
      }
      this._microempresario.aceptarPropuesta(json)
        .subscribe((data: any) => {
          if (data.exitoso) {
            this.getPropuestas();
            this.router.navigateByUrl(
              '/microempresario/solicitudAceptada/' + json.idSolicitud
            );
          } else {
            this._sweetAlert.errorModal("Error!", true, data.error);
          }
        });
    }
  }

  getMensajePropuesta() {
    var json = {
      idParametro: mensajeElegirPropuesta,
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.mensajeElegir = respuesta[0].valorParametro;
      },
      (error) => {
        this._sweetAlert.errorModal("Error!", true, error.error);
      }
    );
    var json = {
      idParametro: mensajeSeleccionarPropuesta,
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.mensajeSeleccion = respuesta[0].valorParametro;
      },
      (error) => {
        this._sweetAlert.errorModal("Error!", true, error.error);
      }
    );
  }

  validarNegacion() {
    this.idSegmento = null;
    if (this.idNegacion == 2) {
      this._parametro.getCondicionesFinancieras().subscribe((resp: any) => {
        this.listCondiciones = resp.data;
      }, (error) => {
        this._sweetAlert.errorModal("Error!", true, error.error);
      }, () => {
        setTimeout(() => {
          $('.selectpicker').selectpicker('refresh');
        });
      });
    }
  }

  //Methods CRUD
  getTiposDocumentoSegmento(idSegmento: any) {
    this.tiposDocumentos = [];
    this._microempresario.getDocumentosBySegmento(idSegmento).subscribe((resp: any) => {
      if (resp.exitoso) {
        if (resp.data.tipoDocumento?.length > 0) {
          this.tiposDocumentos = resp.data.tipoDocumento;
          this.getDocumentoSegmento();
        }
      }
    });
  }

  getDocumentoSegmento() {
    this._microempresario.getDocumentosBySolicitudAndSegmento(this.idSegmento, this.idSolicitud).subscribe((data: any) => {
      if (data.documentosSegmentoSolicutd.length > 0) {
        this.documentos = data.documentosSegmentoSolicutd;
      } else {
        this.documentos = [];
      }
    });
  }

  saveFile(event, documento: any) {
    let json: any = null;
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    const filename = file.name.split('.');
    reader.onload = () => {
      json = {
        idSegmento: this.idSegmento,
        idTipoDocumentoSegmento: documento.id,
        idSolicitud: this.idSolicitud,
        nombreDocumento: this.normalizeName(documento.segTipoDocumento.nombre),
        nombreArchivo: this.normalizeName(filename[0]),
        tipoContenido: file.type,
        extension: filename[1],
        archivo: reader.result.toString().split(',')[1],
      };
      const allowedExtensions = documento.segTipoDocumento.segTipoDocExtensions.filter((ext) => ext.estado === 'HABILITADO').map((ext) => ext.extension.toLowerCase());
      if (allowedExtensions.includes(json.extension || '')) {
        this._microempresario.saveFileSegmento(json).subscribe((data: any) => {
          if (data.exitoso) {
            this._sweetAlert.successModal('Archivo subido').then((response) => {
              if (response.isConfirmed) {
                this.getDocumentoSegmento();
              }
            });
          } else {
            this._sweetAlert.errorModal(
              !data.error ? 'No se pudo subir el archivo' : data.error
            );
          }
        });
      } else {
        this._sweetAlert.errorModal(
          `Solo son permitidas las siguientes extensiones: ${this.getAcceptExtensions(documento.segTipoDocumento.segTipoDocExtensions)}`, true
        );
      }
    };
  }

  seeDocument(idDocumento: string) {
    const idDocumentoSegmento = this.documentos.find((item) => item.idTipoDocumentoSegmento === idDocumento)?.idDocumentosSegmento;
    const nombreDocumento = this.documentos.find((item) => item.idTipoDocumentoSegmento === idDocumento)?.nombreDocumento;
    this._microempresario.downloadFileSegmento(idDocumentoSegmento)
      .subscribe((response: any) => {
        const image: string = response.mimeType;
        if (
          response.mimeType === 'application/pdf' ||
          image.split('/')[0] === 'image'
        ) {
          const blob = new Blob([this.base64ToBytes(response.data)], {
            type: response.mimeType,
          });
          let urlFile = window.URL.createObjectURL(blob);
          this.router.navigate([]).then(() => window.open(urlFile));
        } else {
          var a = document.getElementById('downloadFile');
          a.setAttribute(
            'href',
            `data:${response.mimeType};base64,${response.data}`
          );
          a.setAttribute('download', unescape(nombreDocumento));
          a.click();
        }
      });
  }

  base64ToBytes(base64: string) {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  normalizeName(text: string): string {
    return text
      .normalize('NFD') // Descompone caracteres con diacríticos
      .replace(/[\u0300-\u036f]/g, '') // Elimina diacríticos
      .replace(/ñ/g, 'n')
      .replace(/Ñ/g, 'N')
      .trim()
      .replace(/\s+/g, '_'); 
  }

  deleteFile(idDocumento: string) {
    const idDocumentoSegmento = this.documentos.find((item) => item.idTipoDocumentoSegmento === idDocumento)?.idDocumentosSegmento;
    this._microempresario.deleteFileSegmento(idDocumentoSegmento)
      .subscribe((data: any) => {
        if (data.exitoso) {
          this._sweetAlert.successModal('Documento eliminado').then((response) => {
            if (response.isConfirmed) {
              this.getDocumentoSegmento();
            }
          });
        } else {
          this._sweetAlert.errorModal("Error!", true, data.error);
        }
      });
  }

  isDocumento(idDocumento: string): boolean {
    return this.documentos.some((item) => item.idTipoDocumentoSegmento === idDocumento);
  }

  getAcceptExtensions(extensions: any[]): string {
    return extensions
      .filter((ext) => ext.estado === 'HABILITADO') // Filtrar solo extensiones habilitadas
      .map((ext) => `.${ext.extension}`)           // Mapear a formato `.ext`
      .join(',');                                  // Unir en una sola cadena separada por comas
  }

  verificarDocumentosObligatorios(): boolean {
    const obligatorios = this.tiposDocumentos.filter((tipo) => tipo.obligatorio);
    const faltantes = obligatorios.filter((tipo) =>
        !this.documentos.some((doc) => doc.idTipoDocumentoSegmento === tipo.id)
      ).map((tipo) => tipo.nombre);
    return faltantes.length === 0;
  }
  //End Methods CRUD      
}